var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Add, ArrowDownwardOutlined, Check, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Button, Chip, Divider, FilledInput, Grid, Input, OutlinedInput, TextField, Typography, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import { USER_PROFILE_DATA } from '../../api/url';
import { AppointmentKeys } from '../../modules/appointmentV3/services/entity';
import { FFRKeys } from '../../modules/ffr/services/entity';
import { JobCardInvoiceReturnFilter } from '../../modules/jciReturn/component/jciReturnFilter';
import { showSurface } from '../../redux/awaitedSurfacesSlice';
import { setReducerState } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getStatusColor } from '../../theme/statusColors';
import { getLocalStorageItem } from '../../utils/storageHelper';
import { FilterFunnel, LayoutGrid, ListView, Search } from '../assets/svg';
import { getUpdateKey } from '../common/commonFunctions';
import { DynamicCatalogBuilder } from '../components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { DynamicFormBuilderContainer } from '../components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
var sampleQuestions = [{
        groupingPath: ['001'],
        id: 1,
        QuestionGroupId: '001',
        Group: 'Question Group 1'
    }, {
        groupingPath: ['001', 'Q1'],
        id: 2,
        QuestionGroupId: '001',
        Group: 'Question Group 1',
        QuestionId: 'Q1',
        Question: 'Question 1',
        Answer: 'Answer 1'
    }, {
        groupingPath: ['001', 'Q2'],
        id: 3,
        QuestionGroupId: '001',
        Group: 'Question Group 1',
        QuestionId: 'Q2',
        Question: 'Question 2',
        Answer: 'Answer 2'
    }, {
        groupingPath: ['002'],
        id: 4,
        QuestionGroupId: '002',
        Group: 'Question Group 2'
    }, {
        groupingPath: ['002', 'Q4'],
        id: 5,
        QuestionGroupId: '002',
        Group: 'Question Group 2',
        QuestionId: 'Q4',
        Question: 'Question 4',
        Answer: 'Answer 3'
    }];
export default function ListPageDemo() {
    var _this = this;
    var _crud$AppointmentKeys, _crud$AppointmentKeys2, _getLocalStorageItem;
    var dispatch = useAppDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var updateKey = getUpdateKey(FFRKeys.Paging);
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down('sm'); });
    var isNotDesktop = useMediaQuery(function (theme) { return theme.breakpoints.down('md'); });
    var hasMore = !crud[AppointmentKeys.Paging] || ((_crud$AppointmentKeys = crud[AppointmentKeys.Paging]) === null || _crud$AppointmentKeys === void 0 || (_crud$AppointmentKeys = _crud$AppointmentKeys.data) === null || _crud$AppointmentKeys === void 0 ? void 0 : _crud$AppointmentKeys.length) < ((_crud$AppointmentKeys2 = crud[AppointmentKeys.Paging]) === null || _crud$AppointmentKeys2 === void 0 ? void 0 : _crud$AppointmentKeys2.TotalCount);
    var userData = (_getLocalStorageItem = getLocalStorageItem(USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.data;
    var handlePagingUpdate = function () {
        dispatch(setReducerState({
            key: updateKey,
            value: true
        }));
    };
    var tabs = [{
            Name: 'Ready for invoice',
            id: 'ReadyForInvoice',
            count: 32
        }, {
            Name: 'Draft',
            id: 'Draft',
            count: 68
        }, {
            Name: 'Invoiced',
            id: 'Invoiced',
            count: 345
        }];
    var infiniteScrollElements = [{
            type: FormItemTypes.CardComponent,
            name: 'Selected',
            columnSize: 12,
            contentProps: {
                spacing: 0
            },
            setFieldProps: function (formValues, currValue, field) {
                return {
                    type: this.type,
                    sx: {
                        p: 1.5,
                        borderColor: currValue ? 'info.main' : 'secondary.200',
                        bgcolor: currValue ? 'info.50' : 'white'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.CheckBox,
                    name: 'Selected',
                    value: false,
                    label: null,
                    columnSize: 0
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'title-containter',
                    spacing: 0,
                    columnSize: true,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'Group',
                            fontWeight: 'strong',
                            columnSize: 12,
                            textTransform: 'capitalize'
                            // valueGetter(state) {
                            //     return (state?.GivenName + ' ' + state?.FamilyName).toLowerCase()
                            // },
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'Question',
                            color: 'text.secondary',
                            fontSize: 'sm',
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.Chip,
                    name: 'Status',
                    columnSize: 0,
                    size: 'small',
                    shape: 'rounded',
                    setFieldProps: function (formValues, currValue) {
                        return _objectSpread({
                            type: this.type
                        }, getStatusColor(currValue));
                    }
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: false,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 0,
                        p: 1.5,
                        rowSpacing: 1
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'ScheduledDate',
                            label: 'Scheduled Date & Time: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            valueGetter: function (formValues, field) {
                                var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                if (currValue)
                                    return dayjs(currValue).format('DD MMM YYYY - h:mm A');
                                else
                                    return '-';
                            },
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'RegistrationNo',
                            label: 'Registration Number: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'VinNo',
                            label: 'Chassis Number: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ProductName',
                            label: 'Vehicle: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(Typography, {
                                fontSize: "sm",
                                fontWeight: "medium",
                                color: "text.secondary"
                            }, "Comments"),
                            columnSize: 12,
                            textAlign: 'left'
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Mobile',
                            columnSize: 12,
                            placeholder: 'Enter mobile',
                            size: 'small',
                            required: true
                        }],
                    columnSize: 12,
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: this.type,
                            containerProps: {
                                my: currValue ? 1.5 : 0
                            }
                        };
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0.5,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['Close', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['Open', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            columnGap: 1.5,
            alignItems: 'center',
            py: 2.5,
            px: 3,
            elements: [{
                    type: FormItemTypes.SingleSelect,
                    name: 'IdentityId',
                    variant: 'standard',
                    disableUnderline: true,
                    size: 'medium',
                    columnSize: 0,
                    sx: {
                        fontWeight: 'strong'
                    },
                    SelectDisplayProps: {
                        style: {
                            fontSize: 20,
                            lineHeight: '28px'
                        }
                    },
                    slotProps: {
                        input: {
                            sx: {
                                py: 0
                            }
                        }
                    },
                    MenuItemProps: {
                        sx: {
                            fontSize: 'lg'
                        }
                    },
                    options: [{
                            Name: 'All job card invoice',
                            id: 'All'
                        }, {
                            Name: 'My job card invoice',
                            id: 'My'
                        }],
                    value: 'My'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'Count',
                    value: 0,
                    columnSize: 0,
                    color: 'info',
                    size: 'medium'
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12,
            sx: {
                borderColor: 'secondary.200'
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'actions',
            columnSize: 12,
            spacing: 0,
            columnGap: {
                xs: 1,
                sm: 1.5
            },
            alignItems: 'center',
            py: 2,
            px: 3,
            bgcolor: 'secondary.100',
            elements: [
                // {
                //     type: FormItemTypes.TextInput,
                //     name: 'Search',
                //     placeholder: 'Search by chassis no, model, part, repair type',
                //     columnSize: true,
                //     sx: { maxWidth: { xs: 'auto', sm: 400 } },
                //     setFieldProps(formValues, currValue, field, formApi) {
                //         return {
                //             InputProps: {
                //                 startAdornment: <Search id='search-icon' color='secondary' fontSize='small' cursor='pointer' />,
                //             },
                //         }
                //     },
                // },
                {
                    type: FormItemTypes.SearchSelect,
                    name: 'Search',
                    placeholder: 'Search by chassis no, model, part, repair type',
                    columnSize: true,
                    searchFilterPattern: /[\$\.\*\+\?\^\[\]\(\)\\\{\}]/g,
                    sx: {
                        maxWidth: {
                            xs: 'auto',
                            sm: 400
                        }
                    },
                    forcePopupIcon: false,
                    TextFieldProps: {
                        InputProps: {
                            startAdornment: /*#__PURE__*/ React.createElement(Search, {
                                id: "search-icon",
                                color: "secondary",
                                fontSize: "small",
                                cursor: "pointer"
                            })
                        }
                    }
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'View',
                    value: ListView.name,
                    columnSize: 0,
                    sx: {
                        p: {
                            xs: 0.5,
                            md: 0.5
                        },
                        background: 'none'
                    },
                    contentProps: {
                        columnGap: 0.5,
                        spacing: 0
                    },
                    hidden: isMobile,
                    elements: [ListView, LayoutGrid].map(function (Item) { return ({
                        type: FormItemTypes.Button,
                        name: Item.name,
                        color: 'secondary',
                        size: 'icon',
                        columnSize: 0,
                        children: /*#__PURE__*/ React.createElement(Item, {
                            color: "inherit"
                        }),
                        disableRipple: true,
                        disableTouchRipple: true,
                        setFormState: function (state) {
                            return {
                                View: this.name
                            };
                        },
                        setFieldProps: function (formValues) {
                            return {
                                variant: (formValues === null || formValues === void 0 ? void 0 : formValues.View) === this.name ? 'outlined' : 'text',
                                sx: {
                                    color: (formValues === null || formValues === void 0 ? void 0 : formValues.View) === this.name ? 'text.primary' : undefined
                                }
                            };
                        }
                    }); })
                }, {
                    type: FormItemTypes.Button,
                    name: 'Filter',
                    variant: 'outlined',
                    color: 'secondary',
                    columnSize: 0,
                    children: isNotDesktop ? undefined : 'Filter',
                    startIcon: /*#__PURE__*/ React.createElement(FilterFunnel, null),
                    size: isNotDesktop ? 'icon' : 'small',
                    setFormState: function () { return __awaiter(_this, void 0, void 0, function () {
                        var filters;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Drawer',
                                        Component: JobCardInvoiceReturnFilter,
                                        componentProps: {
                                            request: {
                                                Id: 'filter'
                                            }
                                        },
                                        containerProps: {
                                            anchor: 'right',
                                            PaperProps: {
                                                sx: {
                                                    maxWidth: 600
                                                }
                                            }
                                        }
                                    }))];
                                case 1:
                                    filters = _a.sent();
                                    return [2 /*return*/, _objectSpread({}, filters.payload)];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    orientation: 'vertical',
                    columnSize: 0,
                    hidden: isMobile,
                    sx: {
                        borderColor: 'secondary.200'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'Add',
                    variant: 'contained',
                    color: 'primary',
                    columnSize: 0,
                    children: 'Reset',
                    size: 'small',
                    // startIcon: <Add />,
                    hidden: isMobile,
                    setFormState: function (formValues, currValue, field) {
                        var _formValues$Items;
                        return {
                            Items: formValues === null || formValues === void 0 || (_formValues$Items = formValues.Items) === null || _formValues$Items === void 0 ? void 0 : _formValues$Items.map(function (it) { return _objectSpread(_objectSpread({}, it), {}, {
                                Mobile: undefined
                            }); })
                        };
                    }
                }
            ]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12,
            sx: {
                borderColor: 'secondary.200'
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'bottom-fixed-button',
            position: 'fixed',
            bottom: 0,
            px: 3,
            py: 2,
            spacing: 0,
            columnSize: 12,
            hidden: !isMobile,
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Add',
                    variant: 'contained',
                    color: 'primary',
                    columnSize: 12,
                    children: 'New',
                    size: 'small',
                    startIcon: /*#__PURE__*/ React.createElement(Add, null),
                    fullWidth: true
                }]
        },
        // {
        //     type: FormItemTypes.ContainerItem,
        //     name: 'bottom-fixed-button',
        //     px: 3, py: 2, spacing: 0,
        //     columnSize: 12,
        //     hidden: isMobile,
        //     elements: [
        //     ]
        // },
        {
            type: FormItemTypes.Custom,
            name: 'QuestionGroups',
            columnSize: 12,
            value: [{
                    id: 1
                }],
            element: ExampleCatalog,
            containerProps: {
                px: 3,
                py: 2.5
            }
        }
        // {
        //     type: FormItemTypes.Iterator,
        //     name: 'Items',
        //     // getListData: appointmentPagingAPI,
        //     // apiKey: AppointmentKeys.Paging,
        //     // apiRequest: {
        //     //     Branches: [userData?.Branches?.[0]?.OrganizationId],
        //     //     skip: 0, take: 10,
        //     // },
        //     value: sampleQuestions,
        //     gridItemProps: { xs: 12, sm: 6, md: 4, lg: 3 },
        //     elements: infiniteScrollElements,
        //     columnSize: 12,
        //     containerProps: {
        //         container: true, spacing: 2, p: 3,
        //     },
        //     setFormState(formValues, currValue) {
        //         return {
        //             Count: currValue?.reduce((count: number, item: Record<string, string | number>) => item?.Selected ? count + 1 : count, 0)
        //         }
        //     },
        // },
    ];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            spacing: 0
        },
        onChange: function (e, _ref) { return __awaiter(_this, void 0, void 0, function () {
            var field, value, state;
            return __generator(this, function (_a) {
                field = _ref.field, value = _ref.value, state = _ref.state;
                return [2 /*return*/];
            });
        }); } // if (e && field) dispatch(setReducerState({ key: updateKey, value: true }))
        ,
        mode: "edit"
    }));
}
var ExampleCatalog = function (props) {
    var value = props.value, 
    // complete state of form or formValues
    name = props.name, 
    // from formData custom element
    onChange = props.onChange, 
    // internal onChange of form
    error = props.error // complete error state of form
    ;
    var columns = [{
            field: 'Customer',
            headerName: 'Customer',
            flex: 1,
            minWidth: 200,
            editable: true,
            preProcessEditCellProps: function (params) {
                var _params$otherFieldsPr;
                var isValidMobile = ((_params$otherFieldsPr = params.otherFieldsProps) === null || _params$otherFieldsPr === void 0 || (_params$otherFieldsPr = _params$otherFieldsPr.MobileNumber) === null || _params$otherFieldsPr === void 0 || (_params$otherFieldsPr = _params$otherFieldsPr.value) === null || _params$otherFieldsPr === void 0 ? void 0 : _params$otherFieldsPr.length) === 10;
                if (isValidMobile)
                    return {
                        error: false,
                        sx: {
                            outline: undefined,
                            outlineColor: undefined
                        }
                    };
                return {
                    error: true,
                    sx: {
                        outline: '1px solid',
                        outlineColor: 'error.main',
                        outlineOffset: -1
                    }
                };
            },
            cellClassName: function (_ref2) {
                var _row$MobileNumber;
                var row = _ref2.row;
                return (row === null || row === void 0 || (_row$MobileNumber = row.MobileNumber) === null || _row$MobileNumber === void 0 ? void 0 : _row$MobileNumber.length) !== 10 ? 'Mui-error' : '';
            }
        }, {
            field: 'MobileNumber',
            headerName: 'Mobile',
            minWidth: 100,
            editable: true
        }, {
            field: 'ProductName',
            headerName: 'Vehicle',
            flex: 1,
            minWidth: 120
        }, {
            field: 'RegistrationNo',
            headerName: 'Registration No',
            minWidth: 150
        }, {
            field: 'ScheduledDate',
            headerName: 'Scheduled Date',
            valueFormatter: function (value) { return dayjs(value).format('DD MMM, YYYY'); }
        }, {
            field: 'StatusName',
            headerName: 'Status',
            renderCell: function (params) { /*#__PURE__*/ return React.createElement(Chip, _extends({
                label: params.formattedValue
            }, getStatusColor(params.formattedValue))); }
        }];
    return /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        pagingAPIKey: FFRKeys.Paging,
        pagingAPIRequest: {
            IdentityId: (value === null || value === void 0 ? void 0 : value.IdentityId) === 'All' ? null : "16bbd637-2451-4061-9e70-4a03de187baf",
            Status: (value === null || value === void 0 ? void 0 : value.SelectedContracts) === 'All' && value !== null && value !== void 0 && value.SelectedContracts ? null : [value === null || value === void 0 ? void 0 : value.SelectedContracts],
            Branches: ["c247b74a-8222-4363-b693-0d54a710fa08"],
            search: value === null || value === void 0 ? void 0 : value.Search
        }
        // getPagingData={appointmentPagingAPI}
        ,
        rows: [{
                id: 1
            }],
        dataGridProps: {
            cellSelection: false,
            rowSelection: false,
            showColumnVerticalBorder: true,
            sx: {
                '.Mui-error': {
                    outline: '2px solid',
                    outlineColor: 'error.main',
                    bgcolor: 'error.50',
                    outlineOffset: -2
                }
            }
        }
    });
};
var ThemedComponents = function () {
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        sx: {
            p: 3,
            mb: 12
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        variant: "fullWidth",
        textAlign: "left"
    }, "Button")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "small",
        color: "primary"
    }, "Primary - Small")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "medium",
        color: "primary"
    }, "Primary - Medium")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "large",
        color: "primary"
    }, "Primary - Large")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "icon",
        color: "primary"
    }, /*#__PURE__*/ React.createElement(FilterFunnel, null)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        container: true,
        columnSpacing: 2,
        rowSpacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "small",
        color: "secondary",
        variant: "outlined",
        startIcon: /*#__PURE__*/ React.createElement(ArrowDownwardOutlined, null),
        endIcon: /*#__PURE__*/ React.createElement(Check, null)
    }, "Primary - Small")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "medium",
        color: "secondary",
        variant: "outlined"
    }, "Primary - Medium")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "large",
        color: "secondary",
        variant: "outlined"
    }, "Primary - Large")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "icon",
        color: "secondary",
        variant: "outlined"
    }, /*#__PURE__*/ React.createElement(FilterFunnel, null)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "small",
        color: "primary",
        variant: "contained"
    }, "Primary - Small")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "contained"
    }, "Primary - Medium")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "large",
        color: "primary",
        variant: "contained"
    }, "Primary - Large")), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Button, {
        size: "icon",
        color: "primary",
        variant: "contained"
    }, /*#__PURE__*/ React.createElement(FilterFunnel, null)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        variant: "fullWidth",
        textAlign: "left"
    }, "TextField")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(TextField, {
        label: "Textfield",
        size: "medium",
        variant: "standard",
        InputProps: {
            disableUnderline: true
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Input, {
        disableUnderline: true
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(OutlinedInput, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(FilledInput, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        variant: "fullWidth",
        textAlign: "left"
    }, "Chip")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        container: true,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: 'Filled - Circular',
        variant: "filled",
        shape: "circular",
        color: "primary"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: 'Filled - Rounded',
        variant: "filled",
        shape: "rounded",
        color: "info",
        size: "medium"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: 'Filled - Square',
        variant: "filled",
        shape: "square",
        color: "error",
        size: "large"
    })), /*#__PURE__*/ React.createElement(Grid, {
        xs: true
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: 'Outlined - Circular',
        variant: "outlined",
        shape: "circular",
        color: "success"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: 'Outlined - Rounded',
        variant: "outlined",
        shape: "rounded",
        color: "warning"
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: 'Outlined - Square',
        variant: "outlined",
        shape: "square",
        color: "default"
    }))));
};
